import { Component, ElementRef, ViewChild, OnInit, OnDestroy } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {RocketChatService} from "../../../../rocketChat";

declare var $: any;
declare let yaCounter48820577: any;
declare let ym: any;

@Component({
  selector: 'app-universal-callback-button',
  templateUrl: './universal-callback-button.component.html',
  styleUrls: ['./universal-callback-button.component.sass']
})
export class UniversalCallbackButtonComponent implements OnInit, OnDestroy {
  @ViewChild('triggerBtn', { static: false }) triggerBtnRef!: ElementRef;
  open: boolean = false;
  isMobile: boolean = false;
  openQChat: boolean = false;
  unreadMessages: number = 0;

  private handleClickOutside = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    const clickedInsideButton = this.triggerBtnRef?.nativeElement?.contains(target);
    const dialogEl = document.querySelector('.dialog-universal-button');
    const clickedInsideDialog = dialogEl?.contains(target);
    if (!clickedInsideButton && !clickedInsideDialog && !this.openQChat) {
      this.closeDialog();
    }
  };

  constructor(public translate: TranslateService,
              private rocketChat: RocketChatService) {
  }

  ngOnInit() {
    this.isMobile = this.detectMob();

    // Подписываемся на событие открытия QChat из сервиса
    this.rocketChat.openQChat$.subscribe(() => {
      this.openRocketChat();
    });

    // Подписываемся на событие закрытия QChat из сервиса
    this.rocketChat.closeQChat$.subscribe(() => {
      this.closeQChat();
    });
    this.rocketChat.newMessageQChat$.subscribe(() => {
      if (!this.openQChat) {
        this.unreadMessages++;
      }
    });
  }

  ngOnDestroy() {
    this.removeDocumentClickListener();
    this.rocketChat.unmountQChat();
  }

  removeClass() {
    $('body').removeClass('noscroll');
    this.closeDialog();
  }

  openHelpCenter(): void {
    window.open('https://www.ismet.kz/' + this.translate.currentLang + '/ismet-gid/chasto-zadovaemye-voprosy', '_blank');
  }

  closeDialog() {
    this.open = false;
    this.removeDocumentClickListener();
  }

  addDocumentClickListener() {
    document.addEventListener('click', this.handleClickOutside, true);
  }

  removeDocumentClickListener() {
    document.removeEventListener('click', this.handleClickOutside, true);
  }

  openUniversalCallback() {

    if (this.openQChat) {
      this.openQChat = false;
    }

    this.open = !this.open;
    if (this.open) {
      this.addDocumentClickListener();
    } else {
      this.removeDocumentClickListener();
    }
    try {
      yaCounter48820577.reachGoal('konsultant');
    } catch (e) {}

  }

  openRocketChat() {
    this.open = false;
    this.openQChat = true;
    this.unreadMessages = 0;
    $('body').removeClass('noscroll');

    setTimeout(async () => {
      const container = document.querySelector('.q-chat') as HTMLElement;
      if (container) {
        await this.rocketChat.mountQChat(container);
      }
    }, 100);
  }

  closeQChat() {
    this.openQChat = false;
    $('body').removeClass('noscroll');
  }

  openWhatsApp() {
    try {
      yaCounter48820577.reachGoal('whatsapp-konsultant');
    } catch (e) {}
    this.open = false;
    $('body').removeClass('noscroll');
    window.open('https://wa.me/77080000160', '_blank');
  }

  openTelegramBot() {
    this.open = false;
    $('body').removeClass('noscroll');
    window.open('https://t.me/ismetchatBot', '_blank');
    try {
      ym(96365240, 'reachGoal', 'telegram');
    } catch (ignore) {}
  }

  detectMob() {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i
    ];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }
}
